import { render, staticRenderFns } from "./SkeletonBody.vue?vue&type=template&id=70ee3bce"
import script from "./SkeletonBody.vue?vue&type=script&lang=js"
export * from "./SkeletonBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports